module.exports = __webpack_public_path__ + "img/store_UberEats_brown.d2bd1238.svg";